import { render, staticRenderFns } from "./DetailTags.vue?vue&type=template&id=a6159828&"
import script from "./DetailTags.vue?vue&type=script&lang=js&"
export * from "./DetailTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports